var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg041DataPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 205,
    viewBox: "0 0 220 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6024 144.015C39.8362 157.496 48.8962 170.081 62.8386 172.125C76.781 174.168 90.326 164.896 93.0923 151.415C95.8586 137.934 86.7985 125.349 72.8561 123.305C58.9138 121.261 45.3687 130.533 42.6024 144.015Z",
    fill: "url(#paint0_linear_1010_1719)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1449 110.294C78.8876 121.295 86.2808 131.564 97.6581 133.232C109.035 134.9 120.088 127.334 122.346 116.333C124.603 105.332 117.21 95.0617 105.833 93.3941C94.4554 91.7264 83.4023 99.2926 81.1449 110.294Z",
    fill: "url(#paint1_linear_1010_1719)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.029 85.3682C111.265 94.1152 118.147 101.484 127.402 101.826C136.656 102.169 144.779 95.3557 145.544 86.6087C146.308 77.8618 139.426 70.4933 130.171 70.1507C120.916 69.8082 112.794 76.6213 112.029 85.3682Z",
    fill: "url(#paint2_linear_1010_1719)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.015 63.6194C136.245 70.3093 141.525 76.1064 148.807 76.5676C156.089 77.0288 162.616 71.9794 163.385 65.2895C164.155 58.5995 158.875 52.8024 151.593 52.3412C144.311 51.8801 137.784 56.9295 137.015 63.6194Z",
    fill: "url(#paint3_linear_1010_1719)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.89 47.1836C156.278 52.2442 160.135 56.6464 165.504 57.0162C170.874 57.386 175.722 53.5834 176.334 48.5228C176.946 43.4623 173.089 39.0601 167.72 38.6902C162.35 38.3204 157.502 42.123 156.89 47.1836Z",
    fill: "url(#paint4_linear_1010_1719)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.08 34.7369C171.788 38.521 174.794 41.6765 178.793 41.785C182.793 41.8934 186.272 38.9137 186.565 35.1296C186.857 31.3455 183.851 28.1899 179.852 28.0815C175.852 27.9731 172.372 30.9528 172.08 34.7369Z",
    fill: "url(#paint5_linear_1010_1719)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8083 81.2194C18.5965 91.3889 23.9339 104.129 35.7297 109.676C47.5255 115.223 61.3129 111.475 66.5247 101.306C71.7364 91.1361 66.399 78.3956 54.6032 72.849C42.8074 67.3023 29.0201 71.0499 23.8083 81.2194Z",
    fill: "url(#paint6_linear_1010_1719)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1026 64.5873C61.0504 72.9844 66.6279 82.5957 76.5605 86.0548C86.493 89.5139 97.0193 85.5109 100.072 77.1139C103.124 68.7168 97.5462 59.1055 87.6137 55.6464C77.6812 52.1873 67.1549 56.1903 64.1026 64.5873Z",
    fill: "url(#paint7_linear_1010_1719)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.249 49.5442C94.7147 55.9077 98.9285 63.4257 106.661 66.3362C114.393 69.2467 122.715 66.4476 125.25 60.0841C127.784 53.7206 123.57 46.2026 115.838 43.2921C108.106 40.3816 99.7832 43.1807 97.249 49.5442Z",
    fill: "url(#paint8_linear_1010_1719)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M123.321 38.5312C121.371 43.3416 124.409 49.0057 130.107 51.1821C135.805 53.3586 142.005 51.2233 143.955 46.4128C145.905 41.6023 142.867 35.9383 137.169 33.7618C131.471 31.5854 125.271 33.7207 123.321 38.5312Z",
    fill: "url(#paint9_linear_1010_1719)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M143.272 30.1935C141.996 33.8369 144.455 37.9701 148.764 39.4252C153.072 40.8803 157.6 39.1063 158.876 35.4628C160.152 31.8193 157.694 27.6861 153.385 26.2311C149.076 24.776 144.548 26.55 143.272 30.1935Z",
    fill: "url(#paint10_linear_1010_1719)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.597 165.36C104.861 176.464 114.563 184.327 127.267 182.923C139.971 181.519 150.866 171.379 151.602 160.275C152.338 149.171 142.636 141.307 129.932 142.712C117.228 144.116 106.333 154.256 105.597 165.36Z",
    fill: "url(#paint11_linear_1010_1719)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.524 131.484C130.441 140.287 139.991 145.884 150.853 143.984C161.715 142.084 169.777 133.408 168.859 124.605C167.942 115.802 158.393 110.206 147.53 112.106C136.668 114.005 128.606 122.681 129.524 131.484Z",
    fill: "url(#paint12_linear_1010_1719)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.957 103.034C150.384 109.787 157.737 114.186 166.379 112.861C175.021 111.535 181.68 104.986 181.252 98.233C180.825 91.4801 173.473 87.0805 164.831 88.4062C156.189 89.7319 149.53 96.2808 149.957 103.034Z",
    fill: "url(#paint13_linear_1010_1719)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.596 81.3181C166.876 86.4367 172.297 89.8141 178.706 88.8616C185.114 87.9091 190.083 82.9875 189.803 77.8688C189.524 72.7501 184.102 69.3727 177.694 70.3252C171.286 71.2777 166.317 76.1994 166.596 81.3181Z",
    fill: "url(#paint14_linear_1010_1719)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.475 64.7624C179.928 68.5637 184.082 70.951 188.755 70.0947C193.427 69.2383 196.848 65.4625 196.395 61.6612C195.943 57.8599 191.788 55.4725 187.116 56.3289C182.443 57.1853 179.022 60.9611 179.475 64.7624Z",
    fill: "url(#paint15_linear_1010_1719)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1010_1719",
    x1: 195.205,
    y1: 19.7074,
    x2: 63.9121,
    y2: 166.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1010_1719",
    x1: 194.827,
    y1: 20.6796,
    x2: 63.5346,
    y2: 167.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#44A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#277800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1010_1719",
    x1: 194.362,
    y1: 20.9778,
    x2: 61.864,
    y2: 167.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1010_1719",
    x1: 194.379,
    y1: 21.9286,
    x2: 62.1716,
    y2: 168.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6FE200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#66D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#55BC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1010_1719",
    x1: 194.274,
    y1: 22.517,
    x2: 62.1941,
    y2: 169.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1010_1719",
    x1: 194.073,
    y1: 22.9161,
    x2: 61.4219,
    y2: 169.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1010_1719",
    x1: 168.602,
    y1: 30.9446,
    x2: 0.392649,
    y2: 146.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1010_1719",
    x1: 169.615,
    y1: 28.6328,
    x2: 0.434624,
    y2: 145.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1010_1719",
    x1: 169.71,
    y1: 27.6034,
    x2: 0.73034,
    y2: 144.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1010_1719",
    x1: 169.939,
    y1: 26.6799,
    x2: 0.922677,
    y2: 143.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1010_1719",
    x1: 170.113,
    y1: 25.9155,
    x2: 0.952925,
    y2: 143.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1010_1719",
    x1: 215.8,
    y1: 49.8005,
    x2: 125.338,
    y2: 239.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1010_1719",
    x1: 212.21,
    y1: 48.14,
    x2: 120.273,
    y2: 240.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1010_1719",
    x1: 209.019,
    y1: 48.1134,
    x2: 117.944,
    y2: 241.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1010_1719",
    x1: 205.827,
    y1: 47.9387,
    x2: 114.954,
    y2: 241.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1010_1719",
    x1: 202.566,
    y1: 47.8112,
    x2: 110.361,
    y2: 239.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3C9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg041DataPoints);
export default __webpack_public_path__ + "static/media/041-data-points.0752c59b71547917f99ad477d30d4456.svg";
export { ForwardRef as ReactComponent };